import React, { useContext } from "react";
import { useForm } from "react-hook-form";
import {
    Form,
    FormFields,
    FormActions,
    ValidationResult,
    CodedProperty,
    mapToDropdownOption,
    FormDropdown
} from "sprint-common-web";

import { LanguagesDataContext } from "../../../../../../../../common/data/lookup-data-providers/LanguagesDataProvider";
import { ensureSubtitleFileRecordDetails } from "../../../../../../../common/file-record-details/FileRecordDetails";
import { useFileRecordDetailsState } from "../../../../../hooks/useFileRecordDetailsState";

export interface SubtitleFormProps {
    isLoading: boolean;
    onCancel?(): void;
    validationResult?: ValidationResult;
    onSubmit(subtitle?: CodedProperty): void;
}

interface SubtitleFormInputs {
    subtitle: string;
}

export const DynamicSubtitleForm = (props: SubtitleFormProps): JSX.Element => {
    const { fileRecordDetails } = useFileRecordDetailsState();
    const { subtitleLanguages } = useContext(LanguagesDataContext);

    ensureSubtitleFileRecordDetails(fileRecordDetails);

    const defaultSubtitle = subtitleLanguages.find(
        (subtitleLanguage) => subtitleLanguage.id === fileRecordDetails.subtitle?.id
    );

    const { handleSubmit, errors, control } = useForm<SubtitleFormInputs>({
        defaultValues: {
            subtitle: defaultSubtitle ? defaultSubtitle.id : undefined
        }
    });

    const closeClearedAndCallOnClose = () => {
        if (props.onCancel) {
            props.onCancel();
        }
    };

    const callOnSubmit = (formInputs: SubtitleFormInputs) => {
        const subtitleToSubmit = subtitleLanguages.find(
            (subtitleLanguage) => subtitleLanguage.id === formInputs.subtitle
        );

        props.onSubmit(subtitleToSubmit);
    };

    return (
        <Form onSubmit={handleSubmit(callOnSubmit)}>
            <FormFields>
                <FormDropdown
                    options={subtitleLanguages.map((subtitle) => mapToDropdownOption(subtitle))}
                    label="Subtitle"
                    name="subtitle"
                    control={control}
                    errors={errors}
                />
                <FormActions onCancel={closeClearedAndCallOnClose} isLoading={props.isLoading} />
            </FormFields>
        </Form>
    );
};
